import { useLingui } from "@lingui/react";
import { useCallback } from "react";

export const useTranslate = () => {
  const {
    i18n: { locale },
  } = useLingui();
  const translate = useCallback(
    (translatable: { nl: string; fr: string }) => {
      return translatable[locale as "nl" | "fr"];
    },
    [locale]
  );
  return translate;
};
